import React, { memo, useRef } from 'react';
import Select from 'react-select';
import { useQuery } from 'react-query';
import { list } from '../../api/language';
import { Field } from 'redux-form';
import FormInput from '../common/FormInput';
import messages from 'messages/resources';
import { useIntl } from 'react-intl';
import Loader from '../common/Loader';

function LanguagesSelect({ homePage, searchWithinCategory, filter, ...props }: any) {
  const { data = { data: [] }, isLoading } = useQuery(
    ['languageList', { searchWithinCategory: Number(searchWithinCategory), ...filter }],
    (key, params) => {
      return list({ params });
    },
  );
  const { data: languages } = data;
  const { formatMessage } = useIntl();
  const ref = useRef<any>([]);

  if (languages.length) {
    ref.current = languages.map(({ id, language, __meta__ }: any) => ({
      label: language,
      value: id,
      count: __meta__?.resources_count || 0,
    }));
  }

  const { current: options } = ref;
  return homePage ? (
    <Select
      {...props}
      placeholder={formatMessage(messages.fieldLanguage)}
      options={[{ value: null, label: 'All' }, ...options]}
      value={options.filter((item: any) => item.value === Number(props.value))}
      styles={props.styles}
    />
  ) : (
    <Loader loading={isLoading && !options}>
      <Field
        isMulti
        name="languages"
        type="reactSelect"
        component={FormInput}
        options={options}
        placeholder={formatMessage(messages.fieldLanguage)}
        styles={props.styles}
      />
    </Loader>
  );
}

export default memo(LanguagesSelect);
